import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
  gitflicAuthApiRef,
} from '@backstage/core-plugin-api';
import { gitflicPipelinesApiRef, GitflicPipelinesApiClient } from './api';
import { rootRouteRef } from './routes';

export const gitflicPipelinesPlugin = createPlugin({
  id: 'gitflic-pipelines',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: gitflicPipelinesApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        gitflicAuthApi: gitflicAuthApiRef,
      },
      factory: ({ discoveryApi, fetchApi, gitflicAuthApi }) =>
        new GitflicPipelinesApiClient({
          discoveryApi,
          fetchApi,
          gitflicAuthApi,
        }),
    }),
  ],
});

export const GitflicPipelinesCard = gitflicPipelinesPlugin.provide(
  createComponentExtension({
    name: 'GitflicPipelinesCard',
    component: {
      lazy: () =>
        import('./components/GitflicPipelinesCard').then(
          m => m.GitflicPipelinesCard,
        ),
    },
  }),
);

export const GitflicIssuesMergeRequestsContent = gitflicPipelinesPlugin.provide(
  createComponentExtension({
    name: 'GitflicIssuesMergeRequestsContent',
    component: {
      lazy: () =>
        import('./components/GitflicIssuesMergeRequestsContent').then(
          m => m.GitflicIssuesMergeRequestsContent,
        ),
    },
  }),
);
